<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>

    <main class="container py-4">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
            <div>
                <h4 class="fw-bold mb-0">Payment Gateway Providers</h4>
                <div class="text-muted small">Manage provider identities and activation status</div>
            </div>

            <button class="btn btn-outline-secondary btn-sm" type="button" (click)="loadProviders()">
                Refresh
            </button>
        </div>

        <div class="card shadow-sm border-0 mb-4">
            <div class="card-body">
                <div class="fw-semibold mb-3">Create Provider</div>

                <form [formGroup]="createForm" (ngSubmit)="create()" class="row g-3">
                    <div class="col-md-3">
                        <label class="form-label">Code</label>
                        <input class="form-control" formControlName="code" placeholder="FLUTTERWAVE">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Name</label>
                        <input class="form-control" formControlName="name" placeholder="Flutterwave">
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Type</label>
                        <select class="form-select" formControlName="type">
                            <option value="Checkout">Checkout</option>
                            <option value="Card">Card</option>
                            <option value="BankTransfer">BankTransfer</option>
                            <option value="Mixed">Mixed</option>
                        </select>
                    </div>

                    <div class="col-md-2 d-flex align-items-end">
                        <button class="btn btn-primary w-100" type="submit"
                            [disabled]="createForm.invalid || submitting">
                            Create
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <div class="card shadow-sm border-0 mb-3">
            <div class="card-body">
                <label class="form-label">Search</label>
                <input class="form-control" [(ngModel)]="search" (ngModelChange)="applyFilter()" name="providerSearch"
                    placeholder="Search by code, name or type">
            </div>
        </div>

        <div class="card shadow-sm border-0">
            <div class="card-body">
                <div *ngIf="loading" class="text-muted">Loading providers...</div>

                <div class="table-responsive" *ngIf="!loading">
                    <table class="table align-middle">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of filteredProviders">
                                <td>{{ item.code }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.type }}</td>
                                <td>
                                    <span class="badge"
                                        [ngClass]="item.isActive ? 'text-bg-success' : 'text-bg-secondary'">
                                        {{ item.isActive ? 'Active' : 'Inactive' }}
                                    </span>
                                </td>
                                <td class="d-flex gap-2">
                                    <button class="btn btn-sm btn-outline-secondary" type="button"
                                        (click)="openEditModal(item)">
                                        Edit
                                    </button>

                                    <button class="btn btn-sm btn-outline-primary" type="button"
                                        (click)="toggleStatus(item)">
                                        {{ item.isActive ? 'Deactivate' : 'Activate' }}
                                    </button>
                                </td>
                            </tr>

                            <tr *ngIf="filteredProviders.length === 0">
                                <td colspan="5" class="text-center text-muted">No providers found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <app-footer></app-footer>
    </main>
</div>



<!-- Edit Provider Modal -->
<div class="modal fade" id="editProviderModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form [formGroup]="editForm" (ngSubmit)="saveEdit()">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Provider</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body row g-3">
                    <div class="col-12">
                        <label class="form-label">Code</label>
                        <input class="form-control" formControlName="code">
                    </div>

                    <div class="col-12">
                        <label class="form-label">Name</label>
                        <input class="form-control" formControlName="name">
                    </div>

                    <div class="col-12">
                        <label class="form-label">Type</label>
                        <select class="form-select" formControlName="type">
                            <option value="Checkout">Checkout</option>
                            <option value="Card">Card</option>
                            <option value="BankTransfer">BankTransfer</option>
                            <option value="Mixed">Mixed</option>
                        </select>
                    </div>

                    <div class="col-12">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" formControlName="isActive"
                                id="editProviderIsActive">
                            <label class="form-check-label" for="editProviderIsActive">Active</label>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary" [disabled]="editForm.invalid || modalSubmitting">
                        Save Changes
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>